<div class="row">
    <div class="col-md-12">
        <app-hero></app-hero>
    </div>
    <div class="col-md-12">
        <app-pricing-table></app-pricing-table>
    </div>
    <div class="col-md-12">
        <app-operator-workspace-section></app-operator-workspace-section>
    </div>
    <div class="col-md-12">
        <app-managed-support-section></app-managed-support-section>
    </div>
    <!-- Temporarily hidden: pricing calculator
    <div class="col-md-12">
        <app-pricing-calculator></app-pricing-calculator>
    </div>
    -->
    <div class="col-md-12">
        <app-pricing-comparison></app-pricing-comparison>
    </div>
    <div class="col-md-12">
        <app-getting-started-section></app-getting-started-section>
    </div>
    <div class="col-md-12">
        <app-pricing-faq></app-pricing-faq>
    </div>
</div>
